import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

export default function DireccionHorarios() {
    const [solicitudes, setSolicitudes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => { loadSolicitudes(); }, []);

    const loadSolicitudes = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_URL}/direccion/autorizaciones/horarios`);
            const data = await response.json();
            setSolicitudes(data.horarios || []);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEstadoChange = async (id, estado) => {
        try {
            await fetch(`${API_URL}/direccion/autorizaciones/horarios/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ estado })
            });
            loadSolicitudes();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const filtered = solicitudes.filter(s =>
        searchTerm === '' || `${s.nombre} ${s.apellido} ${s.codigo}`.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return <div className="p-6 text-center">Cargando...</div>;

    return (
        <div className="p-4 md:p-6 max-w-full mx-auto">
            <div className="mb-6">
                <h1 className="text-xl font-bold text-gray-800">Direccion Academica &gt; Horarios</h1>
            </div>

            {/* Barra de búsqueda */}
            <div className="mb-4 flex gap-3">
                <div className="flex-1 max-w-md relative">
                    <input
                        type="text"
                        placeholder=""
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-full"
                    />
                    <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                </div>
            </div>

            {/* Tabla de Solicitudes de Cambio de Paralelo */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-3 py-3 text-center font-semibold border">No</th>
                                <th className="px-3 py-3 text-center font-semibold border">Código</th>
                                <th className="px-3 py-3 text-center font-semibold border">Nombres</th>
                                <th className="px-3 py-3 text-center font-semibold border">Apellidos</th>
                                <th className="px-3 py-3 text-center font-semibold border">Carrera</th>
                                <th className="px-3 py-3 text-center font-semibold border">Mención</th>
                                <th className="px-3 py-3 text-center font-semibold border">Asignatura</th>
                                <th className="px-3 py-3 text-center font-semibold border">Paralelo Inicial</th>
                                <th className="px-3 py-3 text-center font-semibold border">Paralelo Modificado</th>
                                <th className="px-3 py-3 text-center font-semibold border">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 ? (
                                <tr><td colSpan="10" className="px-4 py-8 text-center text-gray-500 border">No hay solicitudes pendientes</td></tr>
                            ) : (
                                filtered.map((s, index) => (
                                    <tr key={s.id_solicitud} className="hover:bg-gray-50">
                                        <td className="px-3 py-2 text-center border">{index + 1}</td>
                                        <td className="px-3 py-2 text-center border">{s.codigo || s.codigo_estudiante || '-'}</td>
                                        <td className="px-3 py-2 text-center border">{s.nombre || '-'}</td>
                                        <td className="px-3 py-2 text-center border">{s.apellido || '-'}</td>
                                        <td className="px-3 py-2 text-center border">{s.carrera || '-'}</td>
                                        <td className="px-3 py-2 text-center border">{s.mencion || '-'}</td>
                                        <td className="px-3 py-2 text-center border">{s.asignatura || '-'}</td>
                                        <td className="px-3 py-2 text-center border">{s.paralelo_actual || s.paralelo_inicial || '-'}</td>
                                        <td className="px-3 py-2 text-center border">{s.paralelo_nuevo || s.paralelo_modificado || '-'}</td>
                                        <td className="px-3 py-2 text-center border">
                                            <select
                                                value={s.estado || 'pendiente'}
                                                onChange={(e) => handleEstadoChange(s.id_solicitud, e.target.value)}
                                                className={`px-2 py-1 rounded text-xs font-medium border-0 ${s.estado === 'aprobado' ? 'bg-green-100 text-green-800' :
                                                    s.estado === 'reprobado' ? 'bg-red-100 text-red-800' :
                                                        'bg-gray-100 text-gray-800'
                                                    }`}
                                            >
                                                <option value="aprobado">Aprobado</option>
                                                <option value="reprobado">No Aprobado</option>
                                            </select>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
